import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, IconButton, Menu } from "@mui/material";
import { MouseEvent, ReactNode, useState } from "react";

interface ActionsCellProps {
  id: string | number;
  children: ReactNode;
}

const ActionsCell = ({ id, children }: ActionsCellProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: any) => {
    e.preventDefault();
    setAnchorEl(null);
  };

  return (
    <Box>
      <IconButton
        id={`actions-menu-button-${id}`}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon color="primary" />
      </IconButton>

      <Menu
        id={`actions-menu-${id}`}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock={true}
        MenuListProps={{
          "aria-labelledby": `actions-menu-button-${id}`,
        }}
      >
        {children}
      </Menu>
    </Box>
  );
};
export default ActionsCell;
